


















import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import LicenseTypePara from "../terminals/LicenseTypePara.vue";
import BaseApi from "../../store/modules/base";
import rd from "@/modules/vRoutedefs";

@Component({
    components: {
        "at-license-type-para": LicenseTypePara
    }
})
export default class LicenseTypePopup extends CommonBase {
    @Inject()
    baseApi!: BaseApi;
    @Prop()
    licenseType!: number;

    show: boolean = false;

    open() {
        this.show = true;
    }
    close() {
        this.show = false;
    }

    get docRoute() {
        return {path: rd.docs.priceinfo.path};
    }
}
